import { AppBar, Toolbar, IconButton, Typography, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ShieldIcon from "@mui/icons-material/Shield";
import { useTranslation } from "react-i18next";
import { NAV_DESKTOP_UP } from "./constants";
import { ThemeLangActions } from "./ThemeLangActions";

interface TopBarProps {
  onMenuClick: () => void;
}

export function TopBar({ onMenuClick }: TopBarProps) {
  const { t } = useTranslation();

  return (
    <AppBar
      position="fixed"
      color="inherit"
      elevation={0}
      sx={{
        display: { xs: "flex", [NAV_DESKTOP_UP]: "none" },
        borderBottom: "1px solid",
        borderColor: "divider",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        pt: "env(safe-area-inset-top, 0px)",
      }}
    >
      <Toolbar sx={{ gap: 0.5, px: { xs: 1, sm: 2 }, minHeight: 56 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flex: 1,
            minWidth: 0,
          }}
        >
          <ShieldIcon color="primary" sx={{ flexShrink: 0 }} />
          <Typography
            variant="h6"
            noWrap
            sx={{
              fontWeight: "bold",
            }}
          >
            {t("app.name")}
          </Typography>
        </Box>
        <ThemeLangActions />
        <IconButton edge="end" onClick={onMenuClick} sx={{ flexShrink: 0 }}>
          <MenuIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}
